/** 价格监管电子围栏区域（上饶·婺源），手动实景多边形，景区+外围3km范围 */
export const PRICE_FENCE_REGIONS = [
  {
    id: 'huangling',
    name: '篁岭景区周边',
    matchAreas: ['篁岭景区'],
    // 篁岭实景边界+外围3km不规则多边形
    paths: [
      { lat: 29.338820, lng: 118.121047 },
      { lat: 29.322784, lng: 118.106052 },
      { lat: 29.307445, lng: 118.107909 },
      { lat: 29.301544, lng: 118.121104 },
      { lat: 29.311133, lng: 118.133791 },
      { lat: 29.324260, lng: 118.134130 },
      { lat: 29.338777, lng: 118.121806 }
    ],
    mapCenter: { lat: 29.317598, lng: 118.120339 },
    mapZoom: 13.6,
  },
  {
    id: 'wunvzhou',
    name: '婺女洲度假区周边',
    matchAreas: ['婺女洲度假区'],
    // 婺女洲湖域实景+外围3km多边形
    paths: [
      { lat: 29.296012, lng: 117.86391 },
      { lat: 29.28489933, lng: 117.87127453 },
      { lat: 29.27615954, lng: 117.868031072 },
      { lat: 29.27176409, lng: 117.8606174 },
      { lat: 29.27418919, lng: 117.847991080 },
      { lat: 29.2900014, lng: 117.85077119 },
      { lat: 29.2955578463, lng: 117.857258128 }
    ],
    mapCenter: { lat: 29.28398661918369, lng: 117.85869104914218 },
    mapZoom: 13.8,
  },
  {
    id: 'likeng',
    name: '李坑古村周边',
    matchAreas: ['李坑古村'],
    // 李坑河谷古村实景范围
    paths: [
      { lat: 29.342270427832364, lng: 117.93181957717923 },
      { lat: 29.334545677717184, lng: 117.91634748996489 },
      { lat: 29.32166979852898, lng: 117.91508159014438 },
      { lat: 29.315666616713315, lng: 117.92489732296713 },
      { lat: 29.315310206795505, lng: 117.94147925992922 },
      { lat: 29.328078272967023, lng: 117.94612390710245 },
      { lat: 29.335472428198372, lng: 117.94993988746467 },
      { lat: 29.338202209876837, lng: 117.94052029676095 },
    ],
    mapCenter: { lat: 29.3244360804523, lng: 117.92940582741596 },
    mapZoom: 13.4,
  },
  {
    id: 'jiangling',
    name: '江岭油菜花片区周边',
    matchAreas: ['江岭景区'],
    paths: [
      { lat: 29.47200042004786, lng: 118.022534442006 },
      { lat: 29.46361204436284, lng: 118.0140144044 },
      { lat: 29.420263920912557, lng: 118.04133542885609 },
      { lat: 29.429850667116987, lng: 118.0591952125 },
      { lat: 29.480338936242923, lng: 118.03675215529483 },
    ],
    mapCenter: { lat: 29.452991185350914, lng: 118.033526430 },
    mapZoom: 12.6,
  },
]

export function getPriceFenceRegionById(regionId) {
  return PRICE_FENCE_REGIONS.find(item => item.id === regionId) || PRICE_FENCE_REGIONS[0]
}

export function filterHotelsByFenceRegion(hotels, regionId) {
  const region = getPriceFenceRegionById(regionId)
  if (!region || !region.matchAreas) return hotels.slice()
  return hotels.filter(hotel => region.matchAreas.includes(hotel.area))
}

// ==================== 酒店价格数据 完全保留原有优化内容 ====================
export const accommodationPriceList = [
  // ==================== 篁岭景区 · 投诉=0 ====================
  {
    hotelId: "wy-huangling-shaiqiu",
    hotelName: "婺源篁岭晒秋美宿",
    area: "篁岭景区",
    fenceRegionId: "huangling",
    roomType: "观景大床房",
    realTimePrice: 1250,
    historyAvgPrice: 680,
    premiumRate: 83.82,
    complaintCount30Days: 0,
    complaints: [],
    warnings: [{
      id: "wy-huangling-shaiqiu-1",
      message: "五一假期价格达片区峰值，溢价偏高持续监测",
    }],
  },
  {
    hotelId: "wy-huangling-yishan",
    hotelName: "篁岭倚山居美宿",
    area: "篁岭景区",
    fenceRegionId: "huangling",
    roomType: "山景双床房",
    realTimePrice: 1180,
    historyAvgPrice: 660,
    premiumRate: 78.79,
    complaintCount30Days: 0,
    complaints: [],
    warnings: [{
      id: "wy-huangling-yishan-1",
      message: "近三日价格连续上浮，五一假期涨幅明显",
    }],
  },
  {
    hotelId: "wy-huangling-zhushan",
    hotelName: "篁岭竹山度假酒店",
    area: "篁岭景区",
    fenceRegionId: "huangling",
    roomType: "阳台景观房",
    realTimePrice: 1090,
    historyAvgPrice: 630,
    premiumRate: 73.02,
    complaintCount30Days: 0,
    complaints: [],
    warnings: [{
      id: "wy-huangling-zhushan-1",
      message: "多平台标价存在小幅价差，已标记重点比对",
    }],
  },
  {
    hotelId: "wy-huangling-tianjie",
    hotelName: "篁岭天街酒店",
    area: "篁岭景区",
    fenceRegionId: "huangling",
    roomType: "山间双床房",
    realTimePrice: 960,
    historyAvgPrice: 600,
    premiumRate: 60.00,
    complaintCount30Days: 0,
    complaints: [],
    warnings: [],
  },

  // ==================== 婺女洲度假区 ====================
  {
    hotelId: "wy-wunvzhou-wumeng",
    hotelName: "婺女洲无梦精品酒店",
    area: "婺女洲度假区",
    fenceRegionId: "wunvzhou",
    roomType: "湖景双床房",
    realTimePrice: 931,
    historyAvgPrice: 425,
    premiumRate: 119.05,
    complaintCount30Days: 2,
    complaints: [
      "周末房价小幅上涨 —— 渠道：携程",
      "湖景视野部分楼层受限 —— 渠道：美团",
    ],
    warnings: [{
      id: "wy-wunvzhou-wumeng-1",
      message: "溢价率超110%，五一假期属片区高溢价档位",
    }],
  },
  {
    hotelId: "wy-wunvzhou-guyuanli",
    hotelName: "婺女洲故园里酒店",
    area: "婺女洲度假区",
    fenceRegionId: "wunvzhou",
    roomType: "园林大床房",
    realTimePrice: 860,
    historyAvgPrice: 410,
    premiumRate: 109.76,
    complaintCount30Days: 1,
    complaints: ["入住高峰办理稍慢 —— 渠道：黑猫"],
    warnings: [{
      id: "wy-wunvzhou-guyuanli-1",
      message: "五一周期价格翻倍上涨，纳入重点观察名单",
    }],
  },
  {
    hotelId: "wy-wunvzhou-xinbang",
    hotelName: "婺源鑫邦国际大酒店",
    area: "婺女洲度假区",
    fenceRegionId: "wunvzhou",
    roomType: "行政大床房",
    realTimePrice: 720,
    historyAvgPrice: 380,
    premiumRate: 89.47,
    complaintCount30Days: 1,
    complaints: ["行政楼层备品偶有不足 —— 渠道：携程"],
    warnings: [],
  },
  {
    hotelId: "wy-wunvzhou-huiyi",
    hotelName: "婺女洲徽艺民宿",
    area: "婺女洲度假区",
    fenceRegionId: "wunvzhou",
    roomType: "徽派复式loft",
    realTimePrice: 650,
    historyAvgPrice: 350,
    premiumRate: 85.71,
    complaintCount30Days: 2,
    complaints: [
      "复式楼梯较陡 —— 渠道：美团",
      "夜间街区有少量噪音 —— 渠道：黑猫",
    ],
    warnings: [{
      id: "wy-wunvzhou-huiyi-1",
      message: "平日与节假日价差差距明显，已规范提醒",
    }],
  },

  // ==================== 城区 & 其他 ====================
  {
    hotelId: "wy-county-ji",
    hotelName: "全季酒店(婺源紫阳古城店)",
    area: "紫阳镇城区",
    fenceRegionId: "wuyuan_all",
    roomType: "高级大床房",
    realTimePrice: 352,
    historyAvgPrice: 200,
    premiumRate: 76.0,
    complaintCount30Days: 2,
    complaints: [
      "酒店面积小于平台标注宣传面积 —— 渠道：黑猫",
      "高峰期接待服务效率偏低 —— 渠道：携程",
    ],
    warnings: [{
      id: "wy-county-ji-1",
      message: "线上售价日内存在浮动，已纳入日常监测",
    }],
  },
  {
    hotelId: "wy-likeng-ruyi",
    hotelName: "婺源儒意堂徽院(李坑店)",
    area: "李坑古村",
    fenceRegionId: "likeng",
    roomType: "蜜月大床房",
    realTimePrice: 798,
    historyAvgPrice: 415,
    premiumRate: 92.29,
    complaintCount30Days: 1,
    complaints: ["古村停车需步行 —— 渠道：美团"],
    warnings: [{
      id: "wy-likeng-ruyi-1",
      message: "古村民宿同款房型标价不统一，需规范",
    }],
  },
  {
    hotelId: "wy-jiangling-yunxi",
    hotelName: "江岭云栖小院民宿",
    area: "江岭景区",
    fenceRegionId: "jiangling",
    roomType: "梯田观景房",
    realTimePrice: 688,
    historyAvgPrice: 368,
    premiumRate: 86.96,
    complaintCount30Days: 1,
    complaints: ["山区早晚温差较大 —— 渠道：携程"],
    warnings: [{
      id: "wy-jiangling-yunxi-1",
      message: "旺季临时调整房型上下架节奏，重点监控",
    }],
  },
]

// ==================== 监管预警工单 ====================
export const priceSupervisionWorkOrders = [
  { hotelName: '婺源篁岭晒秋美宿', roomType: '徽式观景大床', premiumPrice: 1250, warningTime: '09:15', premiumRate: 83.82 },
  { hotelName: '篁岭倚山居美宿', roomType: '山景双床房', premiumPrice: 1180, warningTime: '10:22', premiumRate: 78.79 },
  { hotelName: '婺女洲无梦精品酒店', roomType: '湖景双床房', premiumPrice: 931, warningTime: '11:08', premiumRate: 119.05 },
  { hotelName: '婺女洲故园里酒店', roomType: '园林大床房', premiumPrice: 860, warningTime: '14:05', premiumRate: 109.76 },
  { hotelName: '婺源儒意堂徽院(李坑店)', roomType: '蜜月大床房', premiumPrice: 798, warningTime: '16:20', premiumRate: 92.29 },
  { hotelName: '全季酒店(婺源紫阳古城店)', roomType: '高级大床房', premiumPrice: 352, warningTime: '17:30', premiumRate: 76.00 },
]


// WEBPACK FOOTER //
// ./src/utils/priceSupervisionData.js